export var PartnerPermissionName = /*#__PURE__*/ function(PartnerPermissionName) {
    PartnerPermissionName["Permissive"] = "PERMISSIVE";
    PartnerPermissionName["Moderate"] = "MODERATE";
    PartnerPermissionName["Restricted"] = "RESTRICTED";
    return PartnerPermissionName;
}({});
